/**
 * Chunk C1 — once-per-venue credit-note coach dismiss (localStorage).
 */

export function getCreditNoteCoachStorageKey(venueId) {
  return `invoices_credit_note_coach_dismissed_${venueId}`
}

export function isCreditNoteCoachDismissed(venueId) {
  if (!venueId || typeof localStorage === 'undefined') return false
  return localStorage.getItem(getCreditNoteCoachStorageKey(venueId)) === '1'
}

export function dismissCreditNoteCoach(venueId) {
  if (!venueId || typeof localStorage === 'undefined') return
  localStorage.setItem(getCreditNoteCoachStorageKey(venueId), '1')
}

/**
 * Do not block first-try empty. Coach after they have uploaded at least
 * one document (and have not dismissed). Credit-note help also lives
 * behind “How the 3-way match works.”
 */
export function shouldShowCreditNoteCoach(
  venueId,
  { hasInvoices = false } = {},
) {
  if (!venueId) return false
  if (!hasInvoices) return false
  return !isCreditNoteCoachDismissed(venueId)
}
